import React, { useEffect, useState } from 'react';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg';
import { Link } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi'; // Icons for the hamburger menu
import UserProfile from './UserProfile';
import Navbar from './Navbar';

const Menu = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage the hamburger menu visibility

  // Event listener for scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Attach scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the hamburger menu
  };

  return (
    <div
      className={`w-full h-20 flex justify-between items-center px-4 fixed top-0 right-0 left-0 ${
        isScrolled ? 'backdrop-blur-md shadow-md' : 'bg-transparent'
      } z-50 transition-all duration-300`}
    >
      {/* Logo Section */}
      <div className="flex flex-row lg:flex-row items-center sm:flex-col">
        <img src={logo} alt="logo" className="w-36 hover:cursor-pointer" />
        <span style={{fontFamily:'Reem Kufi'}} className="hidden md:block text-lg text-gray-800 ml-4 font-light text-nowrap">
          <span className="text-gray-500 mx-2 text-no"> | </span> دليل سياحتك الحلال
        </span>
      </div>

      {/* Navbar for larger screens */}
      <nav className="hidden md:flex w-full bg-transparent my-0 items-center space-x-6  blur-none rounded-2xl justify-around text-white text-xl font-bold">
        <Link to="/Aboutus" className="text-gray-700 hover:text-gray-900 font-medium mx-4 ">
          عن رحال
        </Link>
        <Link to="/Contactus" className="text-gray-700 hover:text-gray-900 font-medium mx-4">
          تواصل معنا
        </Link>
        <Link to="/OffersPage" className="text-gray-700 hover:text-gray-900 font-medium mx-4">
          عروضنا
        </Link>

        <Navbar />
        
      </nav>

      {/* User Profile and Hamburger Menu */}
      <div className="flex items-center space-x-4 md:space-x-6">
        {/* UserProfile Component */}
        <div className="hidden md:block">
          {/* Placeholder for UserProfile Component */}
          <UserProfile/>

        </div>

        {/* Hamburger Menu for smaller screens */}
        <button
          className="md:hidden text-gray-700 text-3xl focus:outline-none"
          onClick={toggleMenu}
        >
          {isMenuOpen ? <HiX /> : <HiMenu />}
        </button>
      </div>

      {/* Dropdown Menu for Mobile */}
      {isMenuOpen && (
        <div className="absolute top-20 left-0 w-full bg-white shadow-lg z-40">
          <nav className="flex flex-col items-center space-y-4 py-4 ">
            <Link
              to="/Aboutus"
              className="text-gray-700 hover:text-gray-900 font-medium mx-4"
              onClick={toggleMenu}
            >
              عن رحال
            </Link>
            <Link
              to="/Contactus"
              className="text-gray-700 hover:text-gray-900 font-medium mx-4"
              onClick={toggleMenu}
            >
              تواصل معنا
            </Link>
            <Link
              to="/OffersPage"
              className="text-gray-700 hover:text-gray-900 font-medium mx-4"
              onClick={toggleMenu}
            >
              عروضنا
            </Link>
            <UserProfile/>
          </nav>
        </div>
      )}
    </div>
  );
};

export default Menu;
